import { render, staticRenderFns } from "./DataToSendModal.vue?vue&type=template&id=623a3189&scoped=true&lang=html&"
import script from "./DataToSendModal.vue?vue&type=script&lang=js&"
export * from "./DataToSendModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623a3189",
  null
  
)

export default component.exports